export default "__VITE_ASSET__Cj$Igxtm__"